import { Component, OnDestroy, OnInit } from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {UserRole} from "../add-user-role/add-user-role.component";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";



@Component({
  selector: 'app-edit-user-role',
  templateUrl: './edit-user-role.component.html',
  styleUrls: ['./edit-user-role.component.scss']
})
export class EditUserRoleComponent implements OnInit, OnDestroy {
 data: UserRole[] | null =[]
  private _destroyed$ = new Subject<void>();
  constructor(
    private mDatabase: AngularFireDatabase
  ) {
  }

  ngOnInit(): void {
    this.getUserRoleData();
  }

  getUserRoleData(): void {
    this.mDatabase
      .object<UserRole[]>(`TestUsers/Pavan/`)
      .valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(res =>{
      let d = res
      this.data = d
    })



  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  submit(): void {
  }
  onAllChange(d: any): void {
    console.log('all clickd')
    const isChecked = d.all;
    d.add = isChecked;
    d.edit = isChecked;
    d.archive = isChecked;
    d.view = isChecked;
    d.excel = isChecked;
  }
}
